import { Slide } from "@jelly/lesson";
import config from "appConfig";
import theory from "../../theory";

const principle: Slide = {
  title: "Numerical derivation on the sine function",
  description:
    "This animation illustrates numerical derivation. The function to be derived is sine (in red) whose derivative is the cosine (in blue).  You can modify the step h of the derivation or choose a linear or quadratic derivation scheme. The result corresponds to the blue points. The error decreases with the discretisation step and for a given value, quadratic derivation scheme is more accurate. The numerical derivate is sinusoidal but the apparent period is smaller than the one of the original function. This is called the dispersion effect: discretisation induces a stiffening of the system.",
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "iframe",
            options: {
              src: `${config.IFRAMES_REACT_URL}/0301/`,
            },
          },
        },
      },
    },
  },
};

export default principle;
